import { render, staticRenderFns } from "./TransferQueuePopUp.vue?vue&type=template&id=bf6ab4c2&"
import script from "./TransferQueuePopUp.vue?vue&type=script&lang=js&"
export * from "./TransferQueuePopUp.vue?vue&type=script&lang=js&"
import style0 from "./TransferQueuePopUp.vue?vue&type=style&index=0&id=bf6ab4c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports